// import { Link } from "lucide-react";
// import { motion } from "framer-motion";
// import {
//   ShoppingCart,
//   ArrowRight,
//   CreditCard,
//   Package,
//   BarChart3,
// } from "lucide-react";

// export default function EcommercePage() {
//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* Hero Section - Professional */}
//       {/* ================= HERO SECTION ================= */}
//       <section
//         style={{
//           background: `
//       linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),
//       url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1920&q=80')
//     `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "75px 20px", // ⬅️ reduced height
//             color: "white",
//           }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 16 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.55 }}
//           >
//             {/* Badge */}
//             <div
//               style={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 marginBottom: "16px",
//                 background: "rgba(59,130,246,0.14)",
//                 border: "1px solid rgba(59,130,246,0.35)",
//                 padding: "8px 14px",
//                 borderRadius: "6px",
//               }}
//             >
//               <span
//                 style={{
//                   fontSize: "12px", // ⬅️ reduced
//                   fontWeight: 600,
//                   letterSpacing: "1px",
//                   color: "#93c5fd",
//                 }}
//               >
//                 ENTERPRISE E-COMMERCE SOLUTIONS
//               </span>
//             </div>

//             {/* Title */}
//             <h1
//               style={{
//                 fontSize: "44px", // ⬅️ reduced
//                 fontWeight: "700",
//                 marginBottom: "16px",
//                 lineHeight: "1.15",
//                 maxWidth: "700px",
//               }}
//             >
//               Scalable E-Commerce Solutions for Modern Businesses
//             </h1>

//             {/* Description */}
//             <p
//               style={{
//                 fontSize: "16px", // ⬅️ reduced para
//                 maxWidth: "580px",
//                 opacity: 0.95,
//                 lineHeight: "1.55",
//                 marginBottom: "26px",
//               }}
//             >
//               High-performance e-commerce platforms built to increase
//               conversions, streamline operations, and support business growth.
//             </p>

//             {/* Actions */}
//             <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
//               <button
//                 style={{
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "13px 28px", // ⬅️ reduced
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "none",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "8px",
//                 }}
//               >
//                 Get Started <ArrowRight size={16} />
//               </button>

//               <button
//                 style={{
//                   background: "transparent",
//                   color: "white",
//                   padding: "13px 28px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "14px",
//                   border: "1.5px solid rgba(255,255,255,0.35)",
//                   cursor: "pointer",
//                 }}
//               >
//                 View Case Studies
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Key Solutions */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#fafbfc" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Our E-Commerce Solutions
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//               gap: "30px",
//             }}
//           >
//             {[
//               {
//                 icon: ShoppingCart,
//                 title: "Shopping Cart",
//                 items: [
//                   "One-page checkout",
//                   "Multiple payment methods",
//                   "Abandoned cart recovery",
//                 ],
//               },
//               {
//                 icon: CreditCard,
//                 title: "Payment Processing",
//                 items: [
//                   "Stripe integration",
//                   "PayPal support",
//                   "Secure transactions",
//                 ],
//               },
//               {
//                 icon: Package,
//                 title: "Inventory Management",
//                 items: [
//                   "Real-time tracking",
//                   "Stock automation",
//                   "Multi-warehouse support",
//                 ],
//               },
//               {
//                 icon: BarChart3,
//                 title: "Analytics & Reports",
//                 items: [
//                   "Sales insights",
//                   "Customer behavior",
//                   "Revenue tracking",
//                 ],
//               },
//             ].map((solution, idx) => {
//               const Icon = solution.icon;
//               return (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6, delay: idx * 0.1 }}
//                   style={{
//                     background: "white",
//                     padding: "35px",
//                     borderRadius: "8px",
//                     boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//                     border: "1px solid #e5e7eb",
//                     transition: "all 0.3s ease",
//                   }}
//                 >
//                   <Icon
//                     size={36}
//                     style={{ color: "#3b82f6", marginBottom: "16px" }}
//                   />
//                   <h3
//                     style={{
//                       fontSize: "20px",
//                       fontWeight: "bold",
//                       marginBottom: "16px",
//                       color: "#1a202c",
//                     }}
//                   >
//                     {solution.title}
//                   </h3>
//                   <ul style={{ listStyle: "none", padding: 0 }}>
//                     {solution.items.map((item, i) => (
//                       <li
//                         key={i}
//                         style={{
//                           color: "#718096",
//                           marginBottom: "8px",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "8px",
//                         }}
//                       >
//                         <span style={{ color: "#3b82f6" }}>→</span> {item}
//                       </li>
//                     ))}
//                   </ul>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Store Features */}

//       <section
//         style={{
//           padding: "80px 20px",
//           backgroundColor: "#f9fafb",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <div
//           style={{
//             width: "100%",
//             maxWidth: "1100px",
//             backgroundColor: "white",
//             borderRadius: "16px",
//             padding: "60px 40px",
//             boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
//           }}
//         >
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "700",
//               marginBottom: "50px",
//               color: "#1a202c",
//               textAlign: "center",
//             }}
//           >
//             Store Features
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//               gap: "40px",
//             }}
//           >
//             {/* Customer Features */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               style={{
//                 padding: "30px",
//                 borderRadius: "14px",
//                 backgroundColor: "#f8fafc",
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: "22px",
//                   fontWeight: "600",
//                   marginBottom: "25px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Customer Features
//               </h3>

//               {[
//                 "Easy product browsing",
//                 "Advanced search & filters",
//                 "Secure payment gateway",
//                 "Order tracking",
//                 "Review system",
//                 "Wishlist functionality",
//               ].map((feature, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, x: -10 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.4, delay: idx * 0.05 }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     marginBottom: "14px",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: "#3b82f6",
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     ✓
//                   </span>
//                   <span style={{ color: "#2d3748", fontSize: "15px" }}>
//                     {feature}
//                   </span>
//                 </motion.div>
//               ))}
//             </motion.div>

//             {/* Admin Features */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               style={{
//                 padding: "30px",
//                 borderRadius: "14px",
//                 backgroundColor: "#f8fafc",
//               }}
//             >
//               <h3
//                 style={{
//                   fontSize: "22px",
//                   fontWeight: "600",
//                   marginBottom: "25px",
//                   color: "#1a202c",
//                 }}
//               >
//                 Admin Features
//               </h3>

//               {[
//                 "Product management",
//                 "Order processing",
//                 "Customer management",
//                 "Sales reporting",
//                 "Marketing tools",
//                 "Discount management",
//               ].map((feature, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, x: 10 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.4, delay: idx * 0.05 }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     marginBottom: "14px",
//                   }}
//                 >
//                   <span
//                     style={{
//                       color: "#3b82f6",
//                       fontSize: "18px",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     ✓
//                   </span>
//                   <span style={{ color: "#2d3748", fontSize: "15px" }}>
//                     {feature}
//                   </span>
//                 </motion.div>
//               ))}
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Implementation */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#fafbfc" }}>
//         <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "36px",
//               fontWeight: "bold",
//               marginBottom: "50px",
//               color: "#1a202c",
//             }}
//           >
//             Implementation Steps
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "25px",
//             }}
//           >
//             {[
//               {
//                 num: "01",
//                 title: "Planning",
//                 desc: "Define store structure, products, and business model",
//               },
//               {
//                 num: "02",
//                 title: "Design",
//                 desc: "Create beautiful, conversion-focused store design",
//               },
//               {
//                 num: "03",
//                 title: "Development",
//                 desc: "Build robust platform with payment integration",
//               },
//               {
//                 num: "04",
//                 title: "Integration",
//                 desc: "Connect inventory, shipping, and analytics",
//               },
//               {
//                 num: "05",
//                 title: "Testing",
//                 desc: "Thorough testing of all features and transactions",
//               },
//               {
//                 num: "06",
//                 title: "Launch",
//                 desc: "Go live and start accepting orders",
//               },
//             ].map((step, idx) => (
//               <motion.div
//                 key={idx}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.6, delay: idx * 0.1 }}
//                 style={{
//                   background: "white",
//                   padding: "25px",
//                   borderRadius: "12px",
//                   textAlign: "center",
//                   boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
//                 }}
//               >
//                 <div
//                   style={{
//                     fontSize: "28px",
//                     fontWeight: "bold",
//                     color: "#3b82f6",
//                     marginBottom: "10px",
//                   }}
//                 >
//                   {step.num}
//                 </div>
//                 <h3
//                   style={{
//                     fontSize: "18px",
//                     fontWeight: "bold",
//                     marginBottom: "8px",
//                     color: "#1a202c",
//                   }}
//                 >
//                   {step.title}
//                 </h3>
//                 <p style={{ color: "#718096", fontSize: "14px" }}>
//                   {step.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA - Professional */}
//       <section
//         style={{
//           background: "#1e293b",
//           padding: "100px 20px",
//           color: "white",
//         }}
//       >
//         <div
//           style={{ maxWidth: "900px", margin: "0 auto", textAlign: "center" }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <h2
//               style={{
//                 fontSize: "40px",
//                 fontWeight: "700",
//                 marginBottom: "20px",
//                 letterSpacing: "-0.5px",
//               }}
//             >
//               Ready to Launch Your Online Store?
//             </h2>
//             <p
//               style={{
//                 fontSize: "18px",
//                 opacity: 0.85,
//                 marginBottom: "40px",
//                 lineHeight: "1.6",
//                 color: "#cbd5e1",
//               }}
//             >
//               Partner with us to build a powerful e-commerce platform that
//               drives revenue and scales with your business. Our team of experts
//               will guide you through every step of the process.
//             </p>
//             <div
//               style={{
//                 display: "flex",
//                 gap: "16px",
//                 justifyContent: "center",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   background: "#3b82f6",
//                   color: "white",
//                   padding: "16px 36px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "16px",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Schedule Consultation <ArrowRight size={20} />
//               </button>
//               <button
//                 style={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   background: "transparent",
//                   color: "white",
//                   padding: "16px 36px",
//                   borderRadius: "6px",
//                   fontWeight: "600",
//                   fontSize: "16px",
//                   border: "2px solid rgba(255, 255, 255, 0.2)",
//                   cursor: "pointer",
//                 }}
//               >
//                 Request Demo
//               </button>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  ShoppingCart,
  ArrowRight,
  Package,
  CheckCircle2,
  ShieldCheck,
  Zap,
  Globe2,
  LayoutDashboard,
  CreditCard,
  PlusCircle,
  Database,
  Smartphone,
  LineChart,
  Search,
  Truck,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function EcommercePage() {
  const adminFeatures = [
    {
      title: "Bulk Product Management",
      desc: "Add and manage thousands of products with multi-variant support effortlessly.",
      icon: PlusCircle,
    },
    {
      title: "Unified Payment Sync",
      desc: "Native integration with Razorpay, Paytm, and Stripe with real-time tracking.",
      icon: CreditCard,
    },
    {
      title: "Order Orchestration",
      desc: "Automated workflow from order placement to shipping label generation.",
      icon: Database,
    },
  ];

  const storeSolutions = [
    {
      icon: ShoppingCart,
      title: "Optimized Shopping Cart",
      items: [
        "One-page checkout",
        "Multiple payment methods",
        "Abandoned cart recovery",
      ],
    },
    {
      icon: CreditCard,
      title: "Payment Processing",
      items: [
        "Razorpay & Stripe integration",
        "UPI & Netbanking support",
        "Secure 256-bit encryption",
      ],
    },
    {
      icon: Package,
      title: "Inventory Management",
      items: [
        "Real-time stock tracking",
        "Auto-restock alerts",
        "Multi-warehouse support",
      ],
    },
    {
      icon: LineChart,
      title: "Analytics & Reports",
      items: [
        "Sales velocity insights",
        "Customer behavior maps",
        "Revenue forecasting",
      ],
    },
  ];

  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0f172a]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1920&q=80')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/90 to-transparent" />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-6">
              Digital Commerce
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">E-Commerce</span>{" "}
              Ecosystems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              We architect high-conversion digital storefronts designed for
              global scale, seamless payment orchestration, and sub-second
              performance.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all shadow-lg flex items-center gap-2"
              >
                Launch Your Store <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= KEY SOLUTIONS GRID ================= */}
      <section className="py-24 bg-slate-50 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Service Stack
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Technical Domain Excellence
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {storeSolutions.map((solution, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-8 rounded-2xl border border-slate-200 shadow-sm hover:shadow-xl transition-all group"
              >
                <solution.icon
                  size={32}
                  className="text-indigo-600 mb-6 group-hover:scale-110 transition-transform"
                />
                <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight">
                  {solution.title}
                </h3>
                <ul className="space-y-3">
                  {solution.items.map((item, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-2 text-[13px] text-slate-500 font-light"
                    >
                      <ArrowRight size={12} className="text-indigo-600" />{" "}
                      {item}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= ADMIN CONTROL CENTER (UNIQUE LAYOUT) ================= */}
      <section className="py-24 bg-slate-950 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-indigo-500 rounded-full blur-[120px]" />
        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-20 items-center">
            <div className="order-2 lg:order-1">
              <div className="relative">
                <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 shadow-2xl scale-105 origin-right">
                  <div className="flex items-center gap-2 mb-6 border-b border-slate-800 pb-4">
                    <LayoutDashboard className="text-indigo-400" size={20} />
                    <span className="text-xs font-bold text-white uppercase tracking-widest">
                      Admin Dashboard v2.0
                    </span>
                  </div>
                  <div className="space-y-4">
                    <div className="h-2 w-1/3 bg-slate-800 rounded"></div>
                    <div className="grid grid-cols-3 gap-2">
                      <div className="h-16 bg-indigo-500/10 border border-indigo-500/20 rounded-lg flex items-center justify-center">
                        <PlusCircle size={20} className="text-indigo-400" />
                      </div>
                      <div className="h-16 bg-slate-800 rounded-lg"></div>
                      <div className="h-16 bg-slate-800 rounded-lg"></div>
                    </div>
                    <div className="h-24 w-full bg-slate-800/50 rounded-xl border border-slate-800"></div>
                  </div>
                </div>
                <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl hidden md:flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center text-green-600">
                    <CheckCircle2 size={20} />
                  </div>
                  <div>
                    <p className="text-[10px] text-slate-400 font-bold uppercase">
                      Payment Verified
                    </p>
                    <p className="text-sm font-bold text-slate-900">
                      Razorpay Sync
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <span className="text-indigo-400 text-[11px] font-bold tracking-[0.2em] uppercase block mb-4 text-left">
                Total Control
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 tracking-tight leading-tight text-left">
                An Admin Engine Built for <br />
                <span className="text-slate-500">Complex Operations.</span>
              </h2>

              <div className="space-y-8">
                {adminFeatures.map((item, i) => (
                  <motion.div
                    key={i}
                    {...fadeUp}
                    transition={{ delay: i * 0.1 }}
                    className="flex gap-6 text-left"
                  >
                    <div className="w-12 h-12 shrink-0 bg-white/5 border border-white/10 rounded-xl flex items-center justify-center text-indigo-400">
                      <item.icon size={24} />
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-white mb-2">
                        {item.title}
                      </h4>
                      <p className="text-sm text-slate-400 font-light leading-relaxed max-w-sm">
                        {item.desc}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= STORE FEATURES (BLUE CARDS) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-8">
            <motion.div
              {...fadeUp}
              className="bg-indigo-50/50 p-10 rounded-3xl border border-indigo-100"
            >
              <h3 className="text-2xl font-bold text-slate-900 mb-8">
                Customer Experience
              </h3>
              <div className="grid sm:grid-cols-2 gap-4">
                {[
                  "Intuitive Browsing",
                  "Advanced Filters",
                  "Secure Checkout",
                  "Order Tracking",
                  "Wishlist Sync",
                  "Instant Reviews",
                ].map((f) => (
                  <div
                    key={f}
                    className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm border border-indigo-50"
                  >
                    <CheckCircle2
                      size={18}
                      className="text-indigo-600 shrink-0"
                    />
                    <span className="text-sm font-semibold text-slate-700">
                      {f}
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              {...fadeUp}
              transition={{ delay: 0.2 }}
              className="bg-slate-900 p-10 rounded-3xl"
            >
              <h3 className="text-2xl font-bold text-white mb-8">
                Backend Management
              </h3>
              <div className="grid sm:grid-cols-2 gap-4">
                {[
                  "Product Catalog",
                  "Order Processing",
                  "Customer CRM",
                  "Sales Analytics",
                  "Tax Management",
                  "Discount Logic",
                ].map((f) => (
                  <div
                    key={f}
                    className="flex items-center gap-3 bg-white/5 border border-white/10 p-4 rounded-xl backdrop-blur-sm"
                  >
                    <CheckCircle2
                      size={18}
                      className="text-indigo-400 shrink-0"
                    />
                    <span className="text-sm font-medium text-slate-300">
                      {f}
                    </span>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ================= IMPLEMENTATION ROADMAP ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Implementation Roadmap
            </h2>
          </div>
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-4">
            {[
              {
                num: "01",
                t: "Discovery",
                d: "Defining store structure and model.",
              },
              { num: "02", t: "Design", d: "Conversion-focused UI design." },
              { num: "03", t: "Engineering", d: "Payment & API integration." },
              { num: "04", t: "Logic", d: "Inventory & shipping setup." },
              {
                num: "05",
                t: "Validation",
                d: "Rigorous transaction testing.",
              },
              { num: "06", t: "Launch", d: "Live deployment & support." },
            ].map((step, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                transition={{ delay: idx * 0.1 }}
                className="bg-white p-6 rounded-2xl border border-slate-200 text-center"
              >
                <span className="text-2xl font-black text-blue-500 block mb-2">
                  {step.num}
                </span>
                <h4 className="font-bold text-slate-900 text-sm mb-2">
                  {step.t}
                </h4>
                <p className="text-[11px] text-slate-500 leading-relaxed font-light">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-indigo-900/20 to-transparent" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 tracking-tight">
            Architect Your Digital Growth.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Ready to integrate advanced commerce logic into your business? Let's
            discuss your technical roadmap.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-10 py-3 rounded-xl text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}